import React from 'react';
import { Suspense, lazy } from 'react';
import './blocklisting.scss';
import { Helmet } from "react-helmet";
import Globals from "../../api";
import ReactHtmlParser from 'react-html-parser';

const ElectionPoll = React.lazy(() => import("../../components/Electionpoll/ElectionPoll"));
const TopNews = React.lazy(() => import('../../components/TopNews/topnews'));
const TrandingNews = React.lazy(() => import('../../components/TrandingPagelist/trandingnews'));
const Horroscope = React.lazy(() => import('../../components/horroscope/horroscope'));
const SpecialVideo = React.lazy(() => import('../../components/SpecialVideo/specialvideo'));
const PageList1 = React.lazy(() => import('../../components/Pagelist1/PageList1'));
const PageList2 = React.lazy(() => import('../../components/Pagelist2/PageList2'));
const PageList3 = React.lazy(() => import('../../components/Pagelist3/PageList3'));
const PageList4 = React.lazy(() => import('../../components/Pagelist4/PageList4'));
const Pagelist5 = React.lazy(() => import('../../components/Pagelist5/PageList5'));
const Pagelist6 = React.lazy(() => import('../../components/Pagelist6/PageList6'));
const PageList7 = React.lazy(() => import('../../components/Pagelist7/PageList7'));
const PageList8 = React.lazy(() => import('../../components/Pagelist8/PageList8'));
const PageList9 = React.lazy(() => import('../../components/Pagelist9/PageList9'));
const PageList10 = React.lazy(() => import('../../components/Pagelist10/PageList10'));
const PageList11 = React.lazy(() => import('../../components/Pagelist11/PageList11'));
const HomeVideoswidget = React.lazy(() => import( '../../components/home_videos/home_videos'));
const BloggerWidget= React.lazy(() => import( '../../components/BloggerWidget/bloggerwidget'));
const MarketWidget = React.lazy(() => import( '../../components/MarketWidget/Marketwidget'));
const CoronaTracker = React.lazy(() => import( '../../components/Coronatracker/Coronatracker'));
const OpinionWidget = React.lazy(() => import( '../../components/opinionwidget/Opinionwidget'));
const CricketUpdate = React.lazy(() => import( '../../components/CricketUpdate/Cricketupdate'));
const TimelineWidget = React.lazy(() => import( '../../components/Timeline/Timeline'));
const Hp_top_300_250 = React.lazy(() => import( '../ad-units/Hp_top_300_250'));
const ROS_Middle_Center_728_90 = React.lazy(() => import( '../ad-units/ros_middle_center_728_90'));
const Ros_bottom_center_728_90 = React.lazy(() => import( '../ad-units/Ros_bottom_center_728_90'));
const Hp_top_center_728_90 = React.lazy(() =>
  import("../ad-units/Hp_top_center_728_90")
);
import ROS_Top_336_280 from '../ad-units/ros_top_300_250';
// import ROS_Middle_Center_336_280 from '../ad-units/ros_middle_center_728_90';
// import Ros_bottom_center_728_90 from '../ad-units/Ros_bottom_center_728_90';

export default class BlockListing extends React.Component { 
    
    convertToArr = (arr) => {
        var output = [];
        arr.forEach((value) => {
          if (Array.isArray(value)) {
            output = [...output, ...this.convertToArr(value)];
          } else {
            output.push(value);
          }
        });
        return output;
      };
    render() {
        let url = window.location.pathname;
        let ElectionPollObj = this.props.data.filter((x) => x.Type == "ElectionPoll" ||  x.Type == "InteractiveTimeline");
        let PollListData = this.props.data.filter((x)=>x.Type == "Poll");
       const DataItems = ElectionPollObj.map((item, i ) => {
       if(item.Type == "InteractiveTimeline" ){
         return(
                <div key={i}><TimelineWidget dataFromParent = {[item]} /></div>
            )
        }
        if(item.Type == "ElectionPoll" ){
            return(
                   <div key={i}><ElectionPoll dataFromParent = { ReactHtmlParser(item.electionHtml)} /></div>
               )
           }
     } )
     let navData = this.props.navigationMenu;
     let rawMenu = navData.filter((x) => x.DefaultUrl == url);
     let rawSubMenu = rawMenu.map((item) => (item.Items));
 
     let subMenuArray = this.convertToArr(rawSubMenu);
     let subMenuItems = subMenuArray.map((item, i) => (
       <li>
         <a href={item.DefaultUrl}>
           {item.Text}
         </a>
       </li>
     ));
    
        const renderLoader = () => <div className='loading_screen'></div>;
        return (

            <div className="home_wrapper">
              <div className="submenu_wrap">
          <div className="container">
            <ul className="cat_sub_menu">{subMenuItems}</ul>
          </div>
        </div>   
                {/* <Helmet>
                <title>{this.props.title}</title>
                <meta name="keywords" content={this.props.meta_keywords} />
                <meta name="description" content={this.props.meta_description} />
                </Helmet> */}
                <div className="full_ads_block">
                 <Suspense fallback={renderLoader()}>
               <ROS_Middle_Center_728_90 AdData= {this.props.AdData}/>
             </Suspense>
             </div>
                <div className="container">
                <Suspense fallback={renderLoader()}>
                    <CoronaTracker dataFromParent={this.props.Coronadata}/>
                    </Suspense>
                </div>
                <section className="container">
                    <div className="row">
                        <div className="col top_news">
                            {/* top news */}
                            <Suspense fallback={renderLoader()}>
                            <TopNews dataFromParent = {this.props.data}/>
                            </Suspense>
                        </div>
                        <div className="col tranding_news">
                            {/* trending news pagelist 1*/}
                            <Suspense fallback={renderLoader()}>
                            <TrandingNews dataFromParent = {this.props.data}/>
                            </Suspense>
                        </div>
                        <div className="col ads_336">
                            <div className="m-b-15 cleafix"></div>
                            <div className="ads_block right_ad">
                            <Suspense fallback={renderLoader()}>
                            <ROS_Top_336_280 AdData= {this.props.AdData}/>
                            </Suspense>
                            </div>
                            <div className="m-b-15"></div>
                            {/* horoscope widget */}
                            <Suspense fallback={renderLoader()}>
                            <Horroscope Horoscope = {this.props.Horoscope}/>
                            </Suspense>
                        </div>
                    </div>
                </section>
                <div className="m-t-15">
                    {/* videos widget */}
                    <Suspense fallback={renderLoader()}>
                <SpecialVideo SpecialVideo = {this.props.videos}/>
                </Suspense>
                </div>
                <div className="m-t-15">
                <Suspense fallback={renderLoader()}>
                   {DataItems}
                   </Suspense>
                </div>
                <section className="h_section3 m-t-20">
                    <div className="container">
                        <div className="row">
                            <div className="col h_l_col">
                                {/* pagelist 1 */}
                                <Suspense fallback={renderLoader()}>
                                <PageList1 dataFromParent = {this.props.data}/>
                                </Suspense>
                                <div className="ads_block m-t-10 m-b-10 ad_middle_center">
                                <Suspense fallback={renderLoader()}>
                                <ROS_Middle_Center_728_90 AdData= {this.props.AdData}/>
                                </Suspense>
                                </div>
                                {/* pagelist 2 */}
                                <Suspense fallback={renderLoader()}>
                                <PageList2 dataFromParent = {this.props.data}/>
                                </Suspense>
                            </div>
                            <div className="col h_r_col">
                                {/* cricket update widget */}
                                <Suspense fallback={renderLoader()}>
                                <CricketUpdate CricketData = {this.props.CricketData}/>
                                </Suspense>
                                <div className="m-b-15"></div>
                                <div className="m-b-15"></div>
                                {/* pagelist 3 */}
                                <Suspense fallback={renderLoader()}>
                                <PageList3 dataFromParent = {this.props.data}/>
                                </Suspense>
                                
                            </div>
                        </div>
                    </div>
                </section>

                <section className="grey_bg padding15">
                    <div className="container">
                    {/* pagelist 4 */}
                    <Suspense fallback={renderLoader()}>
                        <PageList4 dataFromParent = {this.props.data}/>
                        </Suspense>
                    </div>
                </section>

                <section className="padding15">
                    <div className="container">
                        <div className="row">
                            <div className="col-sm-12 col-md-12 col-lg-4">
                            {/* pagelist 5 */}
                            <Suspense fallback={renderLoader()}>
                                <Pagelist5 dataFromParent = {this.props.data}/>
                                </Suspense>
                            </div>
                            <div className="col-sm-12 col-md-12 col-lg-4">
                            {/* pagelist 6 */}
                            <Suspense fallback={renderLoader()}>
                                <Pagelist6 dataFromParent = {this.props.data}/>
                                </Suspense>
                            </div>
                            <div className="col-sm-12 col-md-12 col-lg-4">
                            {/* pagelist 7 */}
                            <Suspense fallback={renderLoader()}>
                                <PageList7 dataFromParent = {this.props.data}/>
                                </Suspense>
                            </div>
                        </div>
                    </div>
                </section>
                {/* photo gallery widget */}
                <Suspense fallback={renderLoader()}>
                <HomeVideoswidget dataFromParent = {this.props.PhotoGallery}/>
                </Suspense>

                <div className='container m-t-20'>
                    <div className='row'>
                        <div className='col'>
                            {/* blog list  */}
                            <Suspense fallback={renderLoader()}>
                            <BloggerWidget dataFromParent = {this.props.data}/>
                            </Suspense>
                            <div className="ads_block m-t-20 m-b-10 ad_bottom_center"> 
                            <Suspense fallback={renderLoader()}>
                                <Ros_bottom_center_728_90 AdData= {this.props.AdData}/>
                                </Suspense></div>
                            <div className="m-b-20 cleafix"></div>
                            <div className="row">
                            {/* pagelist 8 */}
                                <div className="col-sm-12 col-md-12 col-lg-6">
                                <Suspense fallback={renderLoader()}>
                                    <PageList8 dataFromParent = {this.props.data}/>
                                    </Suspense></div>
                            {/* pagelist 9  */}
                                <div className="col-sm-12 col-md-12 col-lg-6">
                                <Suspense fallback={renderLoader()}>
                                    <PageList9 dataFromParent = {this.props.data}/>
                                    </Suspense></div>    
                            </div>
                            <div className="row">
                            
                            {/* pagelist 11  */}
                                <div className="col-sm-12 col-md-12 col-lg-6">
                                <Suspense fallback={renderLoader()}>
                                    <PageList11 dataFromParent = {this.props.data}/>
                                    </Suspense></div>
                                
                            </div>
                            {/* <div className="ads_block m-t-20 m-b-10"> <Suspense fallback={renderLoader()}>
                                <Ros_bottom_center_728_90 AdData= {this.props.AdData}/>
                                </Suspense></div> */}
                        </div>
                        <div className='col h_r_col'>
                            {/* market  */}
                            <Suspense fallback={renderLoader()}>
                            <MarketWidget dataFromParent = {this.props.data}/>
                            </Suspense>
                            <div className="m-b-15 cleafix"></div>
                            {/* opinion */}
                            <Suspense fallback={renderLoader()}>
                            <OpinionWidget dataFromParent = {PollListData} setStateOfParent = {this.props.setStateOfParent}/>
                            </Suspense>
                            <div className="m-b-15 cleafix"></div>
                            {/* pageList 10 */}
                            <Suspense fallback={renderLoader()}>
                            <PageList10 dataFromParent = {this.props.data}/>
                            </Suspense>
                        </div>
                        
                    </div>
                    
                </div>
               
            </div>
        )
    }
}